import React, { useEffect } from 'react';
import Accordion from 'react-bootstrap/Accordion';
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import './Faq.css';
import slide4 from "./../../images/tri_cor.jpg";
import { Link } from 'react-router-dom';
import useNavigation from '../../utils/Navigation';

function Faq() {
    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);

      const navigateToSection = useNavigation()
    
      return (
        <>
                <Header/>
                <div className='faq_banner'><p>FAQ<span>s</span></p></div>
                <Accordion defaultActiveKey={['0']} flush>
                    {/* ,'1','2','3','4','5','6','7','8' */}
                    <div className='container'>
                        <div className='row'>
                            <h2>Frequently Asked Questions</h2>
                            <div className='faq'>
                                <Accordion.Item eventKey="0">
                                    <Accordion.Header>1. Who can participate?</Accordion.Header>
                                        <Accordion.Body>
                                            <p>Approximately 100 participants are expected to take part in this trial.<br/>
To be able to take part in this trial, a patient must meet the following conditions:</p>
                                            <p className='r_arrow'>Any age above 18 years</p>
                                            <p className='r_arrow'>Diagnosed with Myasthenia Gravis (MG)</p>
                                            <p className='r_arrow'>Experiencing symptoms associated with MG</p>
                                            <p>Please note that this list of above conditions is not exhaustive. If you are eligible, all further examinations conducted as part of the study will take place at the hospital/study centre under the supervision of a study physician. The study physician will inform you whether you are eligible to participate in this study</p>
                                        </Accordion.Body>
                                </Accordion.Item>


                                <Accordion.Item eventKey="1" >
                                    <Accordion.Header>2. How is the study being conducted?</Accordion.Header>
                                    <Accordion.Body>
                                    In this study, patients will receive study drug or a placebo. The treatment assignment will be randomly selected by
a computer, which means the treatment you will receive will be based on chance.
                                    </Accordion.Body>
                                </Accordion.Item>

                                <Accordion.Item eventKey="2" >
                                    <Accordion.Header>3. What can I expect during my participation in the trial?</Accordion.Header>
                                    <Accordion.Body>                    
                                        <p>Participation in the trial will take approximately 14 months. During this period, you will have in-person study visits and check-in phone calls.
                                        </p>
                                    </Accordion.Body>
                                </Accordion.Item>

                                <Accordion.Item eventKey="3" >
                                    <Accordion.Header>4. What are the possible benefits and risks of participating in this trial?</Accordion.Header>
                                    <Accordion.Body>
                                        <p>By participating in the trial, you may gain early access to a new potential treatment for Myasthenia gravis (MG). This trial offers the opportunity to contribute to medical
research that could improve treatments for future patients with MG. Your health will be closely monitored by a team of
medical professionals throughout the study.

                                        </p>
                                        <p>However, participation involves potential risks. The study drug has not been widely tested, so its
safety profile is not fully established. You may experience side effects that are currently unknown. There is also a
possibility of receiving placebo instead of the study drug. We ensure rigorous adherence to safety protocols and ethical
standards to manage and minimize any risks.</p>
                                    </Accordion.Body>
                                </Accordion.Item>

                                <Accordion.Item eventKey="4" >
                                    <Accordion.Header>5. Is there a compensation for participants? 
                                    </Accordion.Header>
                                        <Accordion.Body>
                                            <p className="r_arrow">Your participation is valuable. There are no costs to participate in the trial and you may be eligible for your travel costs
to be covered.
                                            </p>
                                        </Accordion.Body>
                                    </Accordion.Item>
                                    <img src={slide4} alt="border" className='bor'/>
                            </div>
                        </div>
               
                    </div>
                </Accordion>
                <Link to = "/#eligibility"  onClick={() => navigateToSection('eligibility')} alt="sticky button"><button className="sticky_eligibility">See if you qualify</button></Link>
                <Footer/>
            </>
  );
}

export default Faq;